<template>
    <Modal 
        v-model="show" 
        :mask-closable="false"  
        :loading="loading"
        @on-ok="confirmHander" 
        @on-cancel="cancelHander">
            <div slot="header" class="modal-header">{{title}}</div>   
            <Form :model="form" :label-width="120"  :rules="formRules" ref="form">
                <template v-if="type === 'add'">
                    <FormItem label="项目" prop="projectFid">
                        <Select v-model="form.projectFid" class="item-width" @on-change="changeProject">
                            <Option value="">请选择</Option>
                            <Option v-for="(item,index) in list.projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="楼栋" prop="buildingFid">
                        <Select v-model="form.buildingFid" class="item-width" @on-change="changeBuild">
                            <Option value="">请选择</Option>
                            <Option v-for="item in list.buildList" :value="item.value" :key="item.value">{{item.text}}</Option>
                        </Select>
                    </FormItem>

                    <FormItem label="IC卡UID" prop="cardUid">
                        <Input v-model="form.cardUid" class="item-width" :maxlength="8"></Input>
                    </FormItem>
                    
                </template>
                <template v-else>
                    <FormItem label="项目">{{projectName}}</FormItem>
                    <FormItem label="楼栋">{{buildingName}}</FormItem>
                    <FormItem label="IC卡UID">{{form.cardUid}}</FormItem>
                </template>
                <FormItem label="卡权限" prop="deviceIds">
                    <Select v-model="form.deviceIds" multiple class="item-width">
                        <Option v-for="(item,index) in list.deviceList" :key="index" :value="item.deviceId">{{item.deviceName}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="有效期截止时间" prop="endTime">
                    <DatePicker type="date" placeholder="请选择" class="item-width" format="yyyy-MM-dd" @on-change="getData" v-model="form.endTime"></DatePicker>
                </FormItem>
            </Form>
    </Modal>
</template>
 
<script type="text/ecmascript-6">
import { getBuildInfo,getDeviceId,addIcList,editIc } from 'api/ladder.js';
export default {
    props: {
        title:{
            type:String,
            default:'添加IC门禁卡'
        },
        value:{
            type:Boolean
        },
        type:{
            type:String,
            default:'add'
        },
        projectName:{
            type:String,
            default:''
        },
        buildingName:{
            type:String,
            default:''
        },
        buildingFid:{
            type:String,
            default:''
        },
        cardUid:{
            type:String,
            default:""
        },
        deviceName:{
            type:String,
            default:""
        },
        endTime:{
            type:String,
            default:""
        },
        deviceIdList:{
            type:Array,
            default:null
        }


    },
    data () {
        const validateEndTime = (rule, value, callback) => {
            if(!value){
                callback(new Error('请选择有效期截止时间'));
            }else{
                callback();
            }
        }

        return {
            show:false,
            loading:true,
            form:{
                projectFid:'',
                buildingFid:'',
                cardUid:'',
                deviceIds:[],
                endTime:null
            },
            formRules:{
                projectFid:[
                    { required: true, message: '请选择项目' ,trigger: 'blur', type:'string'}
                ],
                buildingFid:[
                    { required: true, message: '请选择楼栋' ,trigger: 'blur', type:'string'}
                ],
                cardUid:[
                    { required: true, message: '请输入IC卡' ,trigger: 'blur', type:'string'}
                ],
                deviceIds:[
                    { required: true, message: '请选择设备ID' ,trigger: 'blur', type:'array'}
                ],
                endTime:[
                    { required: true ,trigger: 'blur',validator: validateEndTime}
                ],

            },
            list:{
                projectList:[],
                buildList:[],
                deviceList:[]
            }

        }
    },
    watch: {
        value(val) {
            this.show = val;
            if(val&&this.list.projectList.length === 0){
                this.init();
            }
            if(val&&this.type !== 'add'){
                this.updateFrom();
            }
        },
        show(val) {
            if(!val){
                this.initData();
            }
            this.$emit('input',val)
        } 
    },
    methods: {
        confirmHander() {
            this.$refs['form'].validate(bool => {
                if(!bool){
                    this.changeLoading();
                    return;
                }
                if(this.type === 'add'){
                    this.addIc();
                }else{
                    this.editIcHander();
                }
            })
        },
        cancelHander() {

        },
        init() {
            getBuildInfo().then(res => {
                this.list.projectList = res.data;
            })
        },
        changeProject(value) {
            this.form.buildingFid = '';
            if(value){
                let data = this.list.projectList.filter(item => item.value === value);
                this.list.buildList = data[0]['children'];
            }else{
                this.list.buildList = [];
            }
            
        },
        changeLoading() {
            this.loading = false;
            this.$nextTick(() => {
                this.loading = true
            })
        },
        initData(){
            this.$refs['form'].resetFields();
            this.form.projectFid = '';
            this.form.buildingFid = '';
            this.form.cardUid = '';
            this.form.deviceIds = [];
            this.form.endTime = null;
            this.list.deviceList = [];
        },
        changeBuild(value) {
            if(value){
                this.getDeviceList(value)
            }else{
                this.list.deviceList = [];
            }
        },
        getDeviceList(value) {
            getDeviceId({buildingFid:value}).then(res => {
                console.log(res);
                this.list.deviceList = res.data.deviceList
            })
        },
        addIc() {
            let params = JSON.parse(JSON.stringify(this.form));
            params.deviceIds = params.deviceIds.join(',');
            addIcList(params).then(res => {
                console.log(res);
                this.$emit('refresh');
                this.changeLoading();
                this.$Message.success('添加成功');
                this.show=false;
            })
            .catch(error => {
                this.changeLoading()
            })
        },
        getData(date){
           this.form.endTime = date;
        },
        updateFrom() {
            this.getDeviceList(this.buildingFid);
            this.form.cardUid = this.cardUid;
            this.form.endTime = this.endTime;
            this.form.deviceIds = JSON.parse(JSON.stringify(this.deviceIdList)) 
        },
        editIcHander() {
            let params = JSON.parse(JSON.stringify(this.form));
            params.deviceIds = params.deviceIds.join(',');

            editIc(params).then(res => {
                console.log(res);
                this.$emit('refresh');
                this.$Message.success('更新成功');
                this.changeLoading();
                this.show=false;
            })
            .catch(error => {
                this.changeLoading()
            })
        }

    }
}
</script>